
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[alias]",
      function () {
        return require("private-next-pages/series/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[alias]"])
      });
    }
  